var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9665 7.47021H10.7018C10.4838 9.14596 9.15728 10.4757 7.48328 10.6992V13.9645C10.952 13.7195 13.7268 10.9415 13.9665 7.47021Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.47021C0.2395 10.9412 3.014 13.7195 6.48325 13.9645V10.6985C6.23725 10.6657 5.9945 10.609 5.75925 10.5277C5.23775 10.3475 4.75875 10.0505 4.36425 9.66496C3.9535 9.26396 3.63625 8.76947 3.4455 8.22797C3.35875 7.98197 3.299 7.72796 3.2655 7.47021H0Z",
    fill: "#26B99A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48302 0C3.02202 0.24425 0.252276 3.01025 0.00152588 6.47025H3.26778C3.49553 4.80575 4.81702 3.48774 6.48302 3.26524V0Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48328 0V3.26524C9.14928 3.48774 10.471 4.80575 10.6985 6.47025H13.9648C13.7143 3.0105 10.9445 0.2445 7.48328 0Z",
    fill: "#F0C419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeBoard);
export default __webpack_public_path__ + "static/media/noticeBoard.92bc6507d45dbbc86c961421e5c94b69.svg";
export { ForwardRef as ReactComponent };